import { Link } from '@tanstack/react-router'
import type { AuditType } from '../../api/audit'

/**
 * Cele zece tipuri ca o banda de placute - drumul cel mai scurt intre ele.
 * Macheta `settings/audit/_strip.php`, aceleasi clase: placuta deschisa e
 * `is-on`, "All" duce inapoi la catalog, rularile apar ca un numar mic pe
 * placuta - un fapt, nu un verdict.
 */
export function AuditStrip({
  types,
  current,
  runCounts,
}: {
  types: AuditType[]
  current: number
  runCounts: Record<string, number>
}) {
  return (
    <nav className="od-audit-strip" aria-label="Audit types">
      <Link className={`od-audit-tile${current === 0 ? ' is-on' : ''}`} to="/settings/audit">
        <span className="od-audit-tile-name">
          <i className="fas fa-layer-group" aria-hidden="true"></i> All
        </span>
        <span className="od-audit-tile-meta">catalogue</span>
      </Link>
      {types.map((type) => {
        const runs = runCounts[String(type.id)] ?? 0
        return (
          <Link
            key={type.id}
            className={`od-audit-tile${current === type.id ? ' is-on' : ''}`}
            to="/settings/audit/type/$id"
            params={{ id: String(type.id) }}
            title={type.objective}
          >
            <span className="od-audit-tile-name">{type.title.replace(/ Audit$/, '')}</span>
            <span className="od-audit-tile-meta">
              {type.areas.length} areas
              {runs > 0 && (
                <>
                  {' '}&middot; {runs} run{runs === 1 ? '' : 's'}
                </>
              )}
            </span>
          </Link>
        )
      })}
    </nav>
  )
}
